module.exports = __webpack_public_path__ + "img/ic_doctor_share@2x.f85034ba.png";